import React, { Suspense, lazy, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from 'components/Button';
import Icon from 'components/Icon';

import useFreshchatWidget from 'utils/useFreshchatWidget';

const Header = lazy(() => import('modules/Header'));
const AddProject = lazy(() => import('modules/Projects/container/AddProject'));
const ShareProject = lazy(() =>
  import('modules/Projects/container/ShareProject'),
);

const showPoweredByOn = [
  '/projects',
  '/projects/archived',
  '/projects/web',
  '/projects/illustration',
  '/profile',
  '/project/:projectID',
  '/project/:projectID/:pageID',
  '/project/:projectID/archived',
  '/billing',
  '/upgrade',
  '/team',
  '/team/:teamID',
];

const DashboardLayout = ({
  children,
  user,
  addProjectModal,
  shareProjectModal,
  match,
  teams,
}) => {
  const { openFreshChat } = useFreshchatWidget();

  const getOwnedTeam = useCallback(() => {
    if (teams && teams.length) {
      return teams?.find((t) => t.owner === user.uid) || teams[0];
    }

    return null;
  }, [teams, user]);

  const showRuttlLogo = useCallback(() => {
    const team = getOwnedTeam();

    if (team) return team.isDisabled === false && team.customBranding;

    return false;
  }, [getOwnedTeam]);

  return user && user.uid ? (
    <>
      <Suspense>
        <Header match={match} />
      </Suspense>
      {children}
      {showRuttlLogo() ? null : (
        <div id="powered-by" className="left" style={{ padding: 10 }}>
          <a
            href={
              showRuttlLogo() ? 'https://ruttl.com/' : 'https://www.brucira.com'
            }
            target="_blank"
            rel="noopener noreferrer">
            <img
              src={
                showRuttlLogo()
                  ? '/assets/img/powered-by-ruttl.svg'
                  : '/assets/img/powered-by-brucira.svg'
              }
              alt={`powered by ${showRuttlLogo() ? 'ruttl' : 'brucira'}`}
            />
          </a>
        </div>
      )}
      <Suspense>
        <AddProject show={addProjectModal} />
        <ShareProject show={shareProjectModal} />
      </Suspense>
      {showPoweredByOn.includes(match.path) && (
        <Button
          type="button"
          className="dashboard-contact-us"
          onClick={openFreshChat}>
          <Icon name="love-contact" verticalAlign="middle" />
          <span>Need help?</span>
        </Button>
      )}
    </>
  ) : (
    <></>
  );
};

const mapStateToProps = ({
  user: { user },
  project: { addProjectModal, shareProjectModal },
  team: { teams },
}) => ({
  user,
  addProjectModal,
  shareProjectModal,
  teams,
});

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.object.isRequired,
  addProjectModal: PropTypes.bool.isRequired,
  shareProjectModal: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  teams: PropTypes.array,
};

export default connect(mapStateToProps)(DashboardLayout);
